import { connect } from 'react-redux';
import ExtraInfo from './extra_info';

const mapStateToProps = ({ selection, work }) => ({
  selection,
  aboutPrints: work.data && work.data.aboutPrints,
  id: work.data && work.data.id
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ExtraInfo);
